module.exports = __webpack_public_path__ + "static/introIllustration-0986618416c92a566cac5780317e5a90.svg";